/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';

//获取字典数据项列表
export function dictionayList(param) {
	return request(`${config.server}/api/v1/dms/dictionay/list`,{
		method: 'post',
		body: param
	});
}


//数据项查看
export function dictionayDetail(param) {
	return request(`${config.server}/api/v1/dms/dictionay/detail?${objectSerial(param)}`);
}


//修改数据项
/*
*  {
 active (integer, optional): 状态（1有效，0失效） ,
 dependentDataItemId (integer, optional): 从属数据项id ,
 description (string, optional): 描述 ,
 id (integer, optional): 主键ID ,
 ids (Array[integer], optional),
 itemselector (Array[integer], optional),
 name (string, optional): 数据项名称 ,
 removeFlag (integer, optional): 软删除标识（0：未删除，1已删除） ,
 reqType (integer, optional): 访问类型 ,
 sKey (string, optional): 数据项key ,
 type (integer, optional): 类型（1从属 0 独立）
 }
* */
export function dictionayModify(param) {
	return request(`${config.server}/api/v1/dms/dictionay/modify`,{
		method: 'post',
		body: param
	});
}


//新增数据项
/*
* {
 active (integer, optional): 状态（1有效，0失效） ,
 dependentDataItemId (integer, optional): 从属数据项id ,
 description (string, optional): 描述 ,
 id (integer, optional): 主键ID ,
 ids (Array[integer], optional),
 itemselector (Array[integer], optional),
 name (string, optional): 数据项名称 ,
 removeFlag (integer, optional): 软删除标识（0：未删除，1已删除） ,
 reqType (integer, optional): 访问类型 ,
 sKey (string, optional): 数据项key ,
 type (integer, optional): 类型（1从属 0 独立）
 }
* */
export function dictionayAdd(param){
	return request(`${config.server}/api/v1/dms/dictionay/insert`,{
		method: 'post',
		body: param
	});
}

//获取从属项值
export function listDependent(param) {
	return request(`${config.server}/api/v1/dms/dictionay/listDependent?${objectSerial(param)}`);
}



//删除数据项--传id
export function dictionayDelete(id){
	return request(`${config.server}/api/v1/dms/dictionay/delete`,{
		method: 'post',
		body: id
	});
}




// WEBPACK FOOTER //
// ./src/service/dictionary/index.js